import { Page, Card, Layout, Text } from '@shopify/polaris';

const Settings = () => {
  return (
    <Page title="Settings">
      <Layout>
        <Layout.Section>
          <Card>
            <Text variant="headingMd" as="h2">
              Settings
            </Text>
            <p>Configure your StickyCards settings here.</p>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default Settings;

